import React from 'react';
import { makeStyles, Typography, Card, CardHeader, CardContent, Divider, Box, Button, Chip } from '@material-ui/core';
import parse from 'html-react-parser';

export default function Plano({ data }) {
  const classes = useStyles();
  if (!data) return null;

  const { name, description, price, duration, features, recommended } = data || {};
  const isRecommended = Boolean(recommended) || /ouro|premium|recomendado/i.test(name || '');
  const bgStyle = getPlanBackground(name);
  const waLink = `https://wa.me/5535999500713?text=${encodeURIComponent(
    `Olá, gostaria de patrocinar o Arquivo Roberto Murilo. Plano: ${name || ''}`
  )}`;

  return (
    <Card className={`${classes.card} ${isRecommended ? classes.cardRecommended : ''}`} elevation={3} style={bgStyle}>
      <CardHeader
        title={name || 'Sem nome'}
        action={isRecommended ? (
          <Chip label='Recomendado' color='secondary' size='small' className={classes.badge} />
        ) : null}
      />
      <Divider />
      <CardContent className={classes.cardContent}>
        <Box className={classes.body}>
          {description ? (
            <div className={classes.description}>{parse(description)}</div>
          ) : null}
          {features ? (
            <Typography variant='body2' className={classes.features}>
              {features}
            </Typography>
          ) : null}
        </Box>

        <Box className={classes.priceSection}>
          {price ? (
            <div className={classes.priceRow}>
              <Typography className={classes.price} variant='h4'>
                {formatPrice(price)}
              </Typography>
              <Typography className={classes.perMonth} variant='body2'>
                / mês
              </Typography>
            </div>
          ) : null}
          {duration ? (
            <Typography className={classes.duration} variant='caption'>
              {duration}
            </Typography>
          ) : null}

          <Button
            href={waLink}
            target='_blank'
            rel='noopener noreferrer'
            color='primary'
            variant='contained'
            className={classes.cta}
          >
            Quero patrocinar
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles((theme) => ({
  card: {
    minHeight: '416px',
    width: '100%',
    maxWidth: '345px',
    borderRadius: 16,
    boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid rgba(0,0,0,0.06)'
  },
  cardContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  cardRecommended: {
    border: `2px solid ${theme.palette.primary.main}`,
    boxShadow: '0 10px 24px rgba(0,0,0,0.12)'
  },
  description: {
    fontSize: 14,
    lineHeight: 1.5,
  },
  features: {
    marginTop: 8,
    fontSize: 14,
  },
  priceSection: {
    marginTop: 'auto',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  priceRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 8,
  },
  price: {
    fontWeight: 700,
  },
  perMonth: {
    color: theme.palette.text.secondary,
    marginLeft: 6,
  },
  duration: {
    marginTop: 4,
    color: theme.palette.text.secondary,
  },
  cta: {
    marginTop: 16,
    borderRadius: 999,
    paddingLeft: 24,
    paddingRight: 24,
    textTransform: 'none',
    fontWeight: 600,
  },
  badge: {
    fontWeight: 700,
  },
}));

function formatPrice(value) {
  const n = Number(value);
  if (!isNaN(n)) {
    try {
      return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } catch (e) {
      return `R$ ${n.toFixed(2)}`;
    }
  }
  return value;
}

function getPlanBackground(name = '') {
  const key = (name || '').toLowerCase();
  // Tons suaves/pastel
  if (/ouro|gold|premium/.test(key)) return { backgroundColor: '#FFF8E6' }; // amarelo suave
  if (/prata|silver/.test(key)) return { backgroundColor: '#F4F6F8' }; // cinza claro
  if (/bronze/.test(key)) return { backgroundColor: '#FFF2EB' }; // pêssego claro
  if (/básico|basico|starter|inicial/.test(key)) return { backgroundColor: '#F2F7FF' }; // azul claro
  return { backgroundColor: '#FFFFFF' };
}
